export default __webpack_public_path__ + "static/media/login_root_background.6ac40350.jpg";